import React from 'react';
import { Monitor, CheckCircle, XCircle } from 'lucide-react';

const ScreenShareStep = ({ permissionStatus, checkScreenSharePermission }) => {
  return (
    <div className="flex flex-col items-center p-6">
      <h2 className="text-md font-semibold text-gray-900 mb-6">Screen Sharing Check</h2>
      <div className="mb-6 p-6 bg-gray-50 rounded-full">
        {permissionStatus.screenShare === 'granted' ? (
          <CheckCircle size={64} className="text-green-600" />
        ) : permissionStatus.screenShare === 'denied' ? (
          <XCircle size={64} className="text-red-600" />
        ) : (
          <Monitor size={64} className={`text-blue-600 ${permissionStatus.screenShare === 'checking' ? 'animate-pulse' : ''}`} />
        )}
      </div>

      <p className="text-sm text-gray-600 mb-6 max-w-2xl text-center">
        During the interview, you may be asked to share your screen to demonstrate your skills.
        Let's make sure screen sharing works on your device.
      </p>

      {permissionStatus.screenShare === 'granted' ? (
        <div className="flex items-center p-4 bg-green-50 text-green-700 rounded-md w-full max-w-md">
          <CheckCircle size={24} className="mr-2 flex-shrink-0" />
          <p>Screen sharing works correctly!</p>
        </div>
      ) : permissionStatus.screenShare === 'denied' ? (
        <div className="p-4 bg-red-50 text-red-700 rounded-md w-full max-w-md">
          <p className="mb-4 text-sm">Screen sharing was denied. You'll need to allow screen sharing for the interview.</p>
          <button
            className="px-4 py-2 bg-red-600 hover:bg-red-700 text-white rounded-md transition-colors"
            onClick={checkScreenSharePermission}
          >
            Try Again
          </button>
        </div>
      ) : (
        <div className="flex flex-col items-center p-4 bg-indigo-50 text-blue-700 rounded-md w-full max-w-md">
          <p className="mb-4 text-center text-gray-900 font-medium text-sm">When you click the button below, select the entire screen to share.</p>
          <button
            className="px-4 py-2 bg-indigo-600 hover:bg-indigo-700 text-white rounded-md transition-colors text-sm"
            onClick={checkScreenSharePermission}
          >
            Test Screen Sharing
          </button>
        </div>
      )}
    </div>
  );
};

export default ScreenShareStep;
